module.exports = __webpack_public_path__ + "static/media/games-card.e1030b50.svg";